import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a1ebc64afefc00014bf670e_1780403657451/printhub/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a1ebc64afefc00014bf670e_1780403657451/printhub/src/components/ui/HeroSlider.tsx");
